import { Component, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'event-cancel-dialog',
	template: `
		<event-cancel-dialog-presentation
			(confirmCancellationClicked)="confirmCancellationAndClosePopup($event)"
			(backClicked)="close.emit()">
		</event-cancel-dialog-presentation>
	`
})
export class EventCancelDialogComponent {

	@Output() private confirmCancellation: EventEmitter<string> = new EventEmitter<string>();
	@Output() private close: EventEmitter<void> = new EventEmitter<void>();

	private confirmCancellationAndClosePopup(messageFromMerchant: string) {
		this.confirmCancellation.emit(messageFromMerchant);
		this.close.emit();
	}
};



// WEBPACK FOOTER //
// ./src/app/components/event-components/event-status/event-cancel-dialog/event-cancel-dialog.component.ts